import { BeforeAuthLayoutView } from './BeforeAuthLayoutView';

const AdminLayout = () => {
  return <BeforeAuthLayoutView />;
};

export default AdminLayout;
